import { Field } from "formik";
import React, { type FC, type ReactNode } from "react";

import { FormInputLayout } from "./form_input_layout";

type CheckboxFieldProps = Omit<
  React.ComponentPropsWithoutRef<"input"> & {
    helpElement?: ReactNode;
    label: string;
    name: string;
  },
  "type"
>;

const CheckboxField: FC<CheckboxFieldProps> = ({
  helpElement,
  id,
  label,
  name,
  ...rest
}) => {
  const fieldElement = (
    <Field {...rest} type="checkbox" id={id ?? name} name={name} />
  );

  const props = {
    label,
    name,
    helpElement,
    fieldElement,
  };
  return <FormInputLayout {...props}></FormInputLayout>;
};

export { CheckboxField };
